/* eslint-disable import/prefer-default-export */
import {
  NotificationsApi,
  NotificationsApiNotificationDismissNotificationRequest,
  NotificationsApiNotificationMarkAsReadRequest,
  NotificationsApiNotificationMarkAsUnreadRequest,
  NotificationIdsDTO
} from '../api-client/generated';

const notificationApi = new NotificationsApi();

const getNotificationFeed = async ({ page = 1, dismissed = true }) => {
  const limit = 10;
  const response = await notificationApi.notificationGetNotificationFeed({
    dismissed,
    limit,
    page
  });
  return response;
};

const getUnreadNotificationFeed = async ({ page = 1 }) => {
  const limit = 10;
  const dismissed = false;
  const response = await notificationApi.notificationGetUnreadNotificationFeed({
    dismissed,
    limit,
    page
  });
  return response;
};

const dismissNotification = async ({
  id
}: NotificationsApiNotificationDismissNotificationRequest) => {
  const response = await notificationApi.notificationDismissNotification({
    id
  });
  return response;
};

const markNotificationAsRead = async ({
  id
}: NotificationsApiNotificationMarkAsReadRequest) => {
  const response = await notificationApi.notificationMarkAsRead({ id });
  return response;
};

const markNotificationAsUnread = async ({
  id
}: NotificationsApiNotificationMarkAsUnreadRequest) => {
  const response = await notificationApi.notificationMarkAsUnread({ id });
  return response;
};

const getTotalUnreadNotifications = async () => {
  const response =
    await notificationApi.notificationGetTotalUnreadNotifications();
  return response;
};

const markAllNotificationsAsRead = async () => {
  const response =
    await notificationApi.notificationMarkAllNotificationsAsRead();
  return response;
};

const markAllNotificationsAsDismissed = async () => {
  const response =
    await notificationApi.notificationMarkAllNotificationsAsDismissed();
  return response;
};

const markMultipleNotificationsAsRead = async (ids: string[]) => {
  const notificationIds: NotificationIdsDTO = { ids };
  const response = await notificationApi.notificationMarkNotificationsAsRead({
    notificationIdsDTO: notificationIds
  });
  return response;
};

const markMultipleNotificationsAsDismissed = async (ids: string[]) => {
  const notificationIds: NotificationIdsDTO = { ids };
  const response =
    await notificationApi.notificationMarkNotificationsAsDismissed({
      notificationIdsDTO: notificationIds
    });
  return response;
};

export default {
  dismissNotification,
  getNotificationFeed,
  getTotalUnreadNotifications,
  getUnreadNotificationFeed,
  markAllNotificationsAsDismissed,
  markAllNotificationsAsRead,
  markMultipleNotificationsAsDismissed,
  markMultipleNotificationsAsRead,
  markNotificationAsRead,
  markNotificationAsUnread
};
